// Importing necessary modules and components from React and noteContext.
import React, { useContext } from 'react';
import noteContext from '../Context/notes/notecontext';

// Functional component definition for rendering individual client item.
const ClientItem = (props) => {

    // Destructuring props to extract relevant data.
    const { code, clientName, ActiveStatus, client, updateclient } = props;
    
    // Accessing deleteClient function from the context.
    const context = useContext(noteContext);
    const { deleteClient } = context;

    // Returning JSX to render client item.
    return (
        <>
            <tr >
                {/* Displaying client code */}
                <td>{code === '' ? 'N/A' : code}</td>
                {/* Displaying client name */}
                <td>{clientName === '' ? 'N/A' : clientName}</td>
                {/* Displaying active status with appropriate icon */}
                <td>{ActiveStatus === true ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check2" viewBox="0 0 16 16">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
                </svg> : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                </svg>}</td>
                {/* Buttons for updating and deleting client */}
                <td>
                    {/* Update client button */}
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { updateclient(client) }} width="16" height="16" fill="currentColor" className="bi bi-pencil-fill mx-2" viewBox="0 0 16 16">
                        <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                    </svg>
                    {/* Delete client button */}
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer', color: 'red' }} onClick={() => { deleteClient(client._id) }} width="16" height="16" fill="currentColor" className="bi bi-trash3-fill mx-2" viewBox="0 0 16 16">
                        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                    </svg>
                </td>
            </tr>
        </>
    )
}

export default ClientItem;
